import {
  Component,
  DestroyRef,
  ElementRef,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchMoleculeComponent } from 'src/app/components/input-switch-molecule/input-switch-molecule.component';
import { EditorModule } from 'primeng/editor';

import {
  FormFieldMoleculeComponent,
  LabelAtomComponent,
} from '@ls-commons/components';

import { HttpClient } from '@angular/common/http';
import { CheckboxModule } from 'primeng/checkbox';
import { ModalService } from '@ls-commons/utils/modals';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import jsPDF from 'jspdf';
import { format } from 'date-fns/format';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { NgIf } from '@angular/common';
// import {
//   symptomsValidator,
//   divingWithValidator,
//   divingTypeValidator,
// } from './checkboxes-required.validator';

@Component({
  selector: 'app-convenio-laboral-form',
  standalone: true,
  imports: [
    FormFieldMoleculeComponent,
    ButtonModule,
    SelectButtonModule,
    LabelAtomComponent,
    ReactiveFormsModule,
    SkeletonModule,
    CheckboxModule,
    InputSwitchMoleculeComponent,
    DropdownModule,
    EditorModule,
    CalendarModule,
    FieldsetModule,
    DividerModule,
    ToggleButtonModule,
    NgIf,
  ],
  templateUrl: './convenio-laboral-form.component.html',
  styleUrl: './convenio-laboral-form.component.scss',
})
export class ConvenioLaboralFormComponent {
  convenioLaboralForm!: FormGroup;
  modalService = inject(ModalService);
  destroyRef = inject(DestroyRef);
  http = inject(HttpClient);
  defaultDate = new Date();

  private _isLoading = signal<boolean>(true);
  public isLoading = computed(() => this._isLoading());

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    readonly fb: FormBuilder,
    private el: ElementRef
  ) {
    this.convenioLaboralForm = this.fb.group(
      {
        name: ['', Validators.required],
        nif: ['', Validators.required],
        nombre_director: ['', Validators.required],

        calle: ['', Validators.required],
        numero: ['', Validators.required],
        piso: ['', Validators.required],
        cp: ['', Validators.required],
        ciudad: ['', Validators.required],
        telefono: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]], //

        comun: [''],

        trabajos_offshore: [''],
        trabajos_petroleo: [''],

        explosivos: [''],

        registro_mantenimiento_equipos: [''],

        cobertura_maquinaria_sin_licencia: [''],

        embarcaciones: [''],

        sistemas_buceo: [''],
        producto_diferente_buceo: [''],

        acuerdos_no_reclamacion: [''],

        denegaciones_especiales: [''],

        firma: ['', Validators.required],
        fecha: [new Date(), Validators.required],
        cargo_empresa: ['', Validators.required],
        fecha_inicio_seguro: [new Date(), Validators.required],
      },
      {
        validators: [
          // symptomsValidator(),
          // divingWithValidator(),
          // divingTypeValidator(),
        ],
      }
    );
  }

  closeDialog() {
    this.ref.close(false);
  }

  sendForm() {
    // const form = this.convenioLaboralForm.getRawValue();
    // const observable$ =

    // this.convenioLaboralForm.controls['diving_with'].markAsTouched();
    this.convenioLaboralForm.markAllAsTouched();

    // console.log('convenioLaboralForm', this.convenioLaboralForm.controls);
    // console.log('form_values', form);

    if (this.convenioLaboralForm.valid) {
      const page = document.querySelector('.page') as HTMLElement;
      const convenioLaboralFormData = this.convenioLaboralForm.getRawValue();
      const { nif, fecha } = convenioLaboralFormData;

      const filename = `${nif} ${format(fecha || new Date(), 'Y-m-d')}.pdf`;
      const doc = new jsPDF();
      doc.setProperties({
        title: filename,
      });

      doc.html(page, {
        callback: doc => {
          const pdfBlob = doc.output('blob');
          const reader = new FileReader();
          reader.readAsArrayBuffer(pdfBlob);
          reader.onloadend = () => {
            const pdfArrayBuffer = reader.result as ArrayBuffer;
            const url = `pdf/generate-convenio-pdf?name=${nif}&accident_date=${fecha}`;
            this.http
              .post(url, pdfArrayBuffer, {
                responseType: 'text',
                headers: { 'Content-Type': 'application/pdf' },
              })
              .subscribe({
                next: () => {
                  this.modalService.showSuccessMessage(
                    `Su solicitud ha sido enviada correctamente.`
                  );

                  this.ref.close(true);
                },
                error: () => {
                  this.modalService.showErrorMessage(
                    `El proceso no se ha podido completar.`
                  );
                },
              });
          };
        },
        margin: 5,
        // x: 10,
        y: 5,
        width: 200,
        windowWidth: 900,
      });
    } else {
      this.modalService.showErrorMessage(
        `Es necesario rellenar todos los campos obligatorios`
      );
    }

    if (this.convenioLaboralForm.valid) {
      // Lógica para enviar el formulario
      console.log('Formulario enviado', this.convenioLaboralForm.value);
    } else {
      console.log('Formulario no válido');
    }
  }
}
